// extracted by mini-css-extract-plugin
export default {"container":"TableofContent_container__eGJPJ","video":"TableofContent_video__plPIk"};